<div class="snack-container" [class]="data.type">
    <fa-icon [icon]="iconMap[data.icon]" [ngClass]="{
  'success_tick': data.type === 'success',
  'error_tick': data.type === 'error'}"></fa-icon>
    <span class="message" [ngClass]="{
  'success_message': data.type === 'success',
  'error_message': data.type === 'error'}">{{ data.message | translate  }}</span>
</div>